import {Component, Input, Output, EventEmitter, OnChanges, ViewChild} from '@angular/core';
import { Respondent } from '../model/respondent';
import { ProjectService } from '../project/project.service';
import {Questionnaire} from '../model/questionnaire';
import {QuestionTypeEnum} from '../model/questionTypeEnum';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';


@Component({
    selector: 'respondent',
    template: `
		<div class="card col-md-12">
			<div class="topCommands card-body">
				<button  title="Delete Respondant" class="respondentAction btn btn-danger clickable" (click)="_showAreYouSureDialog = true;" type="submit"><i class="fas fa-times"></i></button>
				<button  [disabled]="!_questionnaireIsValid" title="Update Respondant" class="respondentAction btn btn-primary" (click)="onUpdate(respondent)"><i class="fas fa-pen"></i></button>
				<button *ngIf="questionnaire !=undefined" [disabled]="!questionnaire.sms" title="Send SMS" class="respondentAction btn btn-primary" (click)="sendSMS()"><i class="far fa-comments"></i></button>
				<button *ngIf="questionnaire !=undefined" [disabled]="!questionnaire.email" title="Send Email" class="respondentAction btn btn-primary" (click)="sendEmail()"><i class="far fa-envelope"></i></button>
			</div>
			<div class="panel panel-primary" *ngIf="respondent != null">
				<div class="panel-heading">
					<h3 class="panel-title">{{'details'|translate}}</h3>
					<span (click)="onDetailsClick($event)" [class.panel-collapsed]="_detailsCollapsed" style="margin-top: -20px;" class="pull-right hand"><i [ngClass]="_iClassMap" class="glyphicon"></i></span>
				</div>
				<div [style.display]="_detailsCollapsed ? 'none' : 'inline'" class="panel-body">
					<ul>
						<li>{{'synchroTime'|translate}} : {{respondent.insertedTime}}</li>
						<li>Email Status : {{respondent.emailOpened}}</li>
						<li *ngIf="respondent.clicks!=null && respondent.clicks.length > 0">Clicks
                            <ul>
                                <li *ngFor="let click of respondent.clicks">{{click.href}} {{click.from}} <span class="badge">{{click.total}}</span></li>
                            </ul>
                        </li>
					</ul>
				</div>
			</div>
			<questionnaire-form *ngIf="respondent != null && questionnaire!=null" [respondent]="respondent" [questionnaire]="questionnaire"></questionnaire-form>
		</div>
        <div class="modal" [style.display]="_showAreYouSureDialog ? 'inline' : 'none'">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <button (click)="hideAreYouSureDialog()"  type="button" class="close">&times;</button>
                            <h4 class="modal-title">Juju</h4>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                        Are you sure you want to delete participant?
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" (click)="hideAreYouSureDialog()">Cancel</button>
                            <button type="button" class="btn btn-primary" (click)="deleteRespondent(respondent)">Delete</button>
                        </div>
                    </div>
                </div>
        </div>
    <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>`,
  styles:[`.respondentAction{margin-right:5px;} .topCommands{padding-left:0;}.dynamicDataBtn{float:right;}`]
})
export class RespondentComponent implements OnChanges {
    @Input() respondent: Respondent;
    @Output() respondentDeleted = new EventEmitter();
    @Output() respondentHasChanged = new EventEmitter();
    @Output() respondentUpdated = new EventEmitter();


    private _detailsCollapsed = true;
    private _iClassMap;
    private _showAreYouSureDialog = false;
    private _questionnaireIsValid = true; // TODO: checker incoherant. Quand tu browse des repondant c pcq le questionnaire qu<il ont repondu etait valide.
    private _message = '';
    private _colorText = '';
    private _statusCode = 200;

    private questionnaire:Questionnaire;

    // modal section
    _hideInfoModal = true;
    _genericModalTitle:string;
    _genericModalText:string;

    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    constructor(private _projectService: ProjectService) {
        this._iClassMap = { 'glyphicon-chevron-up': !this._detailsCollapsed, 'glyphicon-chevron-down': this._detailsCollapsed };
    }

    ngOnChanges() {
       this._message = '';
       this._colorText = '';
       this.loadQuestionnaire();
    }

  private loadQuestionnaire() {
    this._projectService.getQuestionnaire(this.respondent.QuestionnaireId).subscribe(
      questionnaire => {
        this.questionnaire = Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(questionnaire,Questionnaire);
      },
      error => console.log('error loading :'+<any>error.toString())
    );
  }

    onDetailsClick(spanElm) {
        this._detailsCollapsed = !this._detailsCollapsed;
        this._iClassMap = { 'glyphicon-chevron-up': !this._detailsCollapsed, 'glyphicon-chevron-down': this._detailsCollapsed };
    }

    onQuestionnaireChange(quest:Questionnaire) {
        // this._questionnaireIsValid = $event !== 'INVALID';

        this.questionnaire = quest;
        this.respondentHasChanged.emit(this._questionnaireIsValid);
    }

    deleteRespondent(respondent) {
        this._projectService.deleteRespondent(respondent.id)
            .then(response => {
                this.respondentDeleted.emit(respondent);
                this._showAreYouSureDialog = false;
            },
            error => {
                console.log('Could not delete the Respondent.');
                this._showAreYouSureDialog = false;
            });
    }

    hideAreYouSureDialog() {
        this._showAreYouSureDialog = false;
    }

    onUpdate(respondent) {
        if (this._questionnaireIsValid) {
            this._message = 'Update in progress...';
            this._colorText = 'orange';
            this._projectService.updateRespondent(respondent).subscribe(
            val => {
                if(val.valueOf() === false) {
                    this.genericModal.defineModal('Failed to update respondent!','Respondent',500);
                    this._hideInfoModal=false;
                } else {
                    this.genericModal.defineModal('Respondent has been updated successfully!','Respondent',200);
                    this._hideInfoModal=false;
                }
              /*this._hideInfoModal = false;
              this._genericModalText = 'Respondent with ID :'+ this.respondent.Id +  ' was successfully updated!';
              this._genericModalTitle = 'Respondent';*/
              this.respondentUpdated.emit(respondent);
            });
        }
    }

    // TODO: A revoir pour l'envoie de SMS
    sendSMS() {
        /*this._message = 'Sending sms ...';
        this._colorText = 'orange';
        this._projectService.sendSMS(respondentId).then(
            msg => {
                this._message = msg;
                this._colorText = 'green';
            });*/
      const smsQuestno = this.questionnaire.getQuestionByType(QuestionTypeEnum.sms);
      this._projectService.sendSMS(this.questionnaire.projectId,this.questionnaire.id,this.respondent.TerminalId,this.respondent.DeviceTypeId,this.respondent.getResponse(smsQuestno).answer,this.respondent.token,this.respondent.Language).subscribe((res) => {
        this._genericModalText = 'An sms was successfully sent to the following number: '+this.respondent.getResponse(smsQuestno).answer;
          if(res === 100) {
              this._genericModalText = 'An sms was successfully sent to the following number: '+this.respondent.getResponse(smsQuestno).answer;
              this.genericModal.defineModal(this._genericModalText,'Respondent',200);
          } else if(res === 102) {
              this._genericModalText = 'An error has occurred while  pushing an SMS to the following number: '+this.respondent.getResponse(smsQuestno).answer;
              this.genericModal.defineModal(this._genericModalText,'Respondent',300);
          }
          this._hideInfoModal = false;
      });
    }

    // TODO: A voir pour l'envoie email
    sendEmail() {
        const emailQuestno = this.questionnaire.getQuestionByType(QuestionTypeEnum.email);
        this._projectService.sendEmail(this.questionnaire.projectId,this.questionnaire.id,this.respondent.TerminalId,this.respondent.DeviceTypeId,this.respondent.getResponse(emailQuestno).answer,this.respondent.Language,this.respondent.token,this.respondent.path).subscribe((msg) => {

            if(msg === 100) {
                this._genericModalText = 'An email was successfully sent to the following address: '+this.respondent.getResponse(emailQuestno).answer;
                this.genericModal.defineModal(this._genericModalText,'Respondent',200);
            } else if(msg === 102) {
                this._genericModalText = 'An error has occurred while  pushing an email to the following address: '+this.respondent.getResponse(emailQuestno).answer;
                this.genericModal.defineModal(this._genericModalText,'Respondent',300);
            }
            this._hideInfoModal = false;
        });
    }

    onOk() {
        this._hideInfoModal = true;
    }
}
